module.exports = __webpack_public_path__ + "media/images/logo__4acesgc-848966890a53a47ea6b9318f2a62e02c.png";